import { CircleHelp } from '@orgus/ui/icons';
import type { ReactNode } from 'react';
import { Button, Popover, PopoverContent, PopoverTrigger, RowStatus, cn } from '@orgus/ui';
import { MARK_ICON } from './ActivityBar.tsx';

function Item({ swatch, label }: { swatch: ReactNode; label: string }) {
  return (
    <li className="flex h-control-sm items-center gap-3 text-ui text-fg-muted">
      <span className="flex w-8 shrink-0 items-center justify-center">{swatch}</span>
      {label}
    </li>
  );
}

const bar = 'h-3 w-8 rounded-control border';

/**
 * What the timeline's shapes mean, behind one "Key" button in the filter bar instead of a
 * legend that crowds it: bar colours (status), idle gaps, and the marks inside a bar.
 */
export function TimelineKey() {
  const Resume = MARK_ICON.resume.icon;
  const Compact = MARK_ICON.compact.icon;
  const Reset = MARK_ICON.reset.icon;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" icon={<CircleHelp />}>
          Key
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-3" aria-label="Timeline key">
        <ul className="flex flex-col">
          <Item swatch={<RowStatus tone="working" icon="working" label="Running" hideLabel focusable={false} />} label="Running: the bar grows to now" />
          <Item swatch={<span className={cn(bar, 'border-status-working-line bg-status-working-soft')} />} label="A run at work" />
          <Item swatch={<span className={cn(bar, 'border-status-danger-line bg-status-danger-soft')} />} label="Failed" />
          <Item swatch={<span className={cn(bar, 'border-border-strong bg-active')} />} label="Done or stopped" />
          <Item swatch={<span className="w-8 border-t border-dashed border-border-strong" />} label="Idle between bursts of work" />
          <Item swatch={<Resume className={cn('size-4', MARK_ICON.resume.className)} aria-hidden />} label="Resumed" />
          <Item swatch={<Compact className={cn('size-4', MARK_ICON.compact.className)} aria-hidden />} label="Context compacted" />
          <Item swatch={<Reset className={cn('size-4', MARK_ICON.reset.className)} aria-hidden />} label="Context reset" />
        </ul>
        <p className="mt-2 border-t border-border-subtle pt-2 text-caption text-fg-subtle">Keys 1, 2 and 3 switch the time window.</p>
      </PopoverContent>
    </Popover>
  );
}
